import { useSelector } from "react-redux";
import "./ReadOnlyBanner.scss";
import React, { FC, Fragment, useState } from "react";
import { selectResellerConfig } from "../../Store/configSlice";
import { selectUserId } from "../../Store/adminSlice";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import close from "../../Assets/icons/close.svg";

interface IReadonlyBannerProps {}

const ReadOnlyBanner: FC<IReadonlyBannerProps> = () => {
  const { t } = useTranslation();
  const resellerConfig = useSelector(selectResellerConfig);
  const userId = useSelector(selectUserId);

  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const closeBanner = () => {
    setIsBannerVisible(false);
  };

  if (isBannerVisible &&
    (
      (resellerConfig && resellerConfig.readonly) || userId)
    ) {
    return (
      <div className="read-only-banner-container">
        <p className="title">{t("readonly.banner.title")}</p>
        <p className="subtitle">-</p>
        <p className="subtitle">{t("readonly.banner.subtitle")}</p>
        <ReactSVG src={close} className="close" onClick={closeBanner}/>
      </div>
    );
  } else {
    return <Fragment />
  }
  
}

export default ReadOnlyBanner;